import React from "react";    
import ConfirmEmailForm from "../../components/Authentication/ConfirmEmailForm";

const ConfirmEmail = () => {
  return (
    <>
      <ConfirmEmailForm />
    </>
  );
};

export default ConfirmEmail;
